import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Témoignages" className="bg-transparent" data-id="element-178" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "17px",
      paddingBottom: "19px"
    }} data-id="element-179" data-mp="3fycr5ou809bu">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-180" data-mp="3azt05a0rs7cm">
          🗣️ Témoignages réels de ceux qui ont commencé
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-181" data-mp="31zd3ajej7ygq">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-182" data-mp="2x007381rtf1h" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}